import { Http } from 'packages/workspace/modules/prelude/http';
import { IAccount, defaultAccount } from '../models/account';
import type { ResponseFormat } from '../models/global-models';

export const FETCH_ACCOUNTS = 'fetchAccounts';
export const FETCH_ACCOUNT = 'fetchAccount';

export const fetchAccounts = async (active: boolean, audit = false, headers = {}): Promise<ResponseFormat<IAccount>> => {
  return await Http.Request<ResponseFormat<IAccount>>('GET', `/workspaces/api/v1/accounts.list?active=${active}&audit=${audit}`, undefined, true, false, headers);
};

export const fetchFSSAccounts = async (): Promise<ResponseFormat<IAccount>> => {
  return await Http.Request<ResponseFormat<IAccount>>('GET', `/workspaces/api/v1/fss-callbacks.accounts`);
};

export const fetchAccount = async (uuid: string): Promise<ResponseFormat<IAccount> | IAccount> => {
  return uuid == '' ? await defaultAccount : await Http.Request<ResponseFormat<IAccount>>('GET', `/workspaces/api/v1/accounts.get?id=${uuid}`);
};
